import { useTranslation } from 'react-i18next';
import { HpButton } from '@hp/ui';

/** Cursor-pagination button. */
export function LoadMore({
  hasNextPage,
  isFetchingNextPage,
  onClick,
  className,
}: {
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  onClick: () => void;
  className?: string;
}) {
  const { t } = useTranslation();
  if (!hasNextPage) return null;
  return (
    <HpButton variant="quiet" icon="chevronDown" className={className} busy={isFetchingNextPage} onClick={onClick}>
      {isFetchingNextPage ? t('actions.loading') : t('actions.loadMore')}
    </HpButton>
  );
}
